(function () {

  const btn = document.querySelector('.back-top')
  if (btn) {

    const goBackTop = () => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    }

    const fillButton = () => {
      const backTopFiller = document.querySelector('.back-top-filler')
      const pageFooter = document.querySelector('.page-footer')

      let scrollTop = window.scrollY
      let docHeight = document.body.offsetHeight
      let winHeight = window.innerHeight
      let scrollPercent = scrollTop / (docHeight - winHeight)
      let scrollPercentRounded = Math.round(scrollPercent * 100)

      backTopFiller.style.height = scrollPercentRounded + '%'

      if (scrollTop >= (docHeight - winHeight - pageFooter.clientHeight + 105)) {
        btn.style.position = 'absolute'
        btn.style.bottom = pageFooter.clientHeight - 35 + 'px'
      }
      else {
        btn.style.position = 'fixed'
        btn.style.bottom = '75px'
      }

    }

    const toggleButton = () => {
      if (window.scrollY > 100) {
        btn.classList.add('show')
      }
      else {
        btn.classList.remove('show')
      }
    }

    goBackTop()
    fillButton()
    toggleButton()

    window.addEventListener('scroll', (e) => {
      fillButton()
      toggleButton()
    })
  }

})()

